import { kibuDrawers } from '@/modules/drawers/data/drawerExamples'
import { DrawerItem } from '@/modules/drawers/types/drawer.types'
import { KibuStoryItem } from '../types/kibuStory.types'

const buildRepairStory = kibuDrawers[0]
const safeStory = kibuDrawers[1]
const sustainableStory = kibuDrawers[2]
const sharingStory = kibuDrawers[3]

const storyMedia = (item: DrawerItem) => ({
    mediaType: item.media.type,
    imageUrl: item.media.url,
    imageAlt: item.media.alt || '',
    posterUrl: item.media.posterUrl,
})

export const kibuStoryItems: KibuStoryItem[] = [
    {
        id: 'build',
        step: '01',
        kicker: 'Build it',
        title: 'Build It Together',
        description: 'More than just headphones – Kibu is a hands-on experience. Build them together, learn how they work, and finish with something they are proud to wear.',
        mediaType: 'video',
        imageUrl: 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/video/build_clips.mp4',
        imageAlt: 'A child building Kibu headphones',
        posterUrl: 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/images/placeholders/build_clips_placeholder.jpg',
        backgroundColor: '#FFD4C4',
        cornerMarks: ['build'],
    },
    {
        id: 'repair',
        step: '02',
        kicker: 'Repair it',
        title: 'Repair, Don’t Replace',
        description: 'If anything breaks, simply replace the part instead of the whole thing. Kids can see how their headphones fit together and help bring them back to life.',
        ...storyMedia(buildRepairStory),
        backgroundColor: '#E6E8FB',
        cornerMarks: ['repair'],
    },
    {
        id: 'safe',
        step: '03',
        kicker: 'Listen safely',
        title: safeStory.title,
        description: safeStory.description,
        ...storyMedia(safeStory),
        backgroundColor: '#FFF1BD',
        cornerMarks: ['safe'],
    },
    {
        id: 'sustainable',
        step: '04',
        kicker: 'Recycle it',
        title: sustainableStory.title,
        description: sustainableStory.description,
        ...storyMedia(sustainableStory),
        backgroundColor: '#DDEBDF',
        cornerMarks: ['recycle'],
    },
    {
        id: 'share',
        step: '05',
        kicker: 'Share it',
        title: sharingStory.title,
        description: sharingStory.description,
        ...storyMedia(sharingStory),
        backgroundColor: '#FFE0D5',
        cornerMarks: ['sharing'],
    },
]
